export default "__VITE_ASSET__2dee66c4__"